import type { CommentTag, CommentTagCatalogue } from '@engagement-web-app/common';

/**
 * Buckets a catalogue's tags by their group id. Ungrouped tags carry the seeded
 * 'UNGROUPED' group, so they come back through the normal group loop.
 */
export function groupTagsByGroupId(catalogue: CommentTagCatalogue | null): Map<string, CommentTag[]> {
    const buckets = new Map<string, CommentTag[]>();

    for (const tag of catalogue?.tags ?? []) {
        const existing = buckets.get(tag.groupId) ?? [];
        existing.push(tag);
        buckets.set(tag.groupId, existing);
    }

    return buckets;
}
